import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "contact-us-error alert--danger alert-box--error alert-box__content"
}
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form__input-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form__label form__label--required"
}, "Contact Name", -1)
const _hoisted_5 = { class: "form__input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form__label form__label--required"
}, "Email", -1)
const _hoisted_7 = { class: "form__input-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "company",
  class: "form__label"
}, "Company", -1)
const _hoisted_9 = { class: "form__input-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "subscriber",
  class: "form__label"
}, "Subscriber ID", -1)
const _hoisted_11 = { class: "form__input-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "form__label form__label--required"
}, "Subject", -1)
const _hoisted_13 = { class: "form__input-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "form__label form__label--required"
}, "Description", -1)
const _hoisted_15 = {
  key: 0,
  class: "recaptha-challenge-message"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Please complete the CAPTCHA challenge to proceed.", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  name: "submit",
  id: "salesForceSubmit",
  class: "btn btn--filled btn--primary btn--lg"
}, null, -1)

import { ref, watch, onMounted } from 'vue'
import { useReCaptcha } from 'vue-recaptcha-v3'
import { log } from '../../../../global/js/utils/logging'
import { RECAPTCHA_V2_SITE_KEY, validateRecaptchaV3, recaptchaChallenge } from '../../../../global/js/utils/recaptcha'


import { defineComponent } from 'vue'
import Vue3Recaptcha from 'vue3-recaptcha2'

const __default__ = defineComponent({
  name: 'SalesforceContactForm',
  components: {
    Vue3Recaptcha,
  },
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { executeRecaptcha, recaptchaLoaded } = useReCaptcha() || {}
const GENERIC_ERROR_MESSAGE = 'An unexpected error has occured. Please try again later.'
const formData = ref({
  name: '',
  email: '',
  company: '',
  subscriber: '',
  subject: '',
  description: '',
  debugEmail: 'ajackson@relias.com',
  debug: '0',
})
const formDataToSend = new FormData()
const error = ref(false)
const errorMessage = ref('')

/**
 * Move the user to the top of the page if an error occurs
 */
watch(error, (newErrorFlag) => {
  if (newErrorFlag) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
})

/**
 * Form Handler
 */
const handleSubmit = async () => {

  // Collect form data
  formDataToSend.append('name', formData.value.name)
  formDataToSend.append('email', formData.value.email)
  formDataToSend.append('company', formData.value.company)
  formDataToSend.append('subject', formData.value.subject)
  formDataToSend.append('description', formData.value.description)
  formDataToSend.append('orgid', '00Dd0000000fdHa')
  formDataToSend.append('retURL', 'https://www.reliasmedia.com/contact-thank-you')
  formDataToSend.append('status', 'New') // Status
  formDataToSend.append('origin', 'Web (Relias Media)') // Case Origin
  formDataToSend.append('external', '1')
  formDataToSend.append('00Nd00000092gp1', formData.value.subscriber)
  formDataToSend.append('00Nd0000007fiPM', 'Relias Media')

  // Optional values used for debugging
  //formDataToSend.append('debugEmail', formData.value.debugEmail) // When uncommented receive email confirmation of form submission with submission details
  formDataToSend.append('debug', formData.value.debug) // When uncommented form submission will show all sent data (does not redirect to thank you page)

  // Recaptcha
  if (recaptchaLoaded && executeRecaptcha) {
    // Get the recaptcha V3 public token
    await recaptchaLoaded()
    const token = await executeRecaptcha('submit')

    // Validate the user
    const recaptchaResult = await validateRecaptchaV3(token)

    if (recaptchaResult.success) {
      // Recaptcha passed
      if (!recaptchaChallenge.value) {
        // Recaptcha passed with a good score
        submitForm(formDataToSend)
      } 
    } else {
      setFormError(GENERIC_ERROR_MESSAGE)
    }
  } else {
    // Recaptcha plugin didn't load
    log('ReCaptcha did not load or executeRecaptcha is not available.', 'src/reliasmedia/js/components/forms/SalesforceContactForm.vue')
    console.error('Recaptcha has thrown an error - see server logs.')
    setFormError(GENERIC_ERROR_MESSAGE)
  }
}

const submitForm = (formDataToSend: FormData) => {
  const form = document.createElement('form')

  form.setAttribute('action', 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')
  form.setAttribute('method', 'POST')

  for (const [key, value] of formDataToSend.entries()) {
    const input = document.createElement('input')
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', key)
    input.setAttribute('value', value as string)
    form.appendChild(input)
  }

  document.body.appendChild(form)
  form.submit()
}

/**
 * V2 Challenge Response handler
 */
const handleRecaptchaV2Response = (token: string) => {
  if (token) {
    submitForm(formDataToSend)
  } else {
    log('Recaptcha v2 validation failed.', 'src/reliasmedia/js/components/forms/SalesforceContactForm.vue')
    setFormError(GENERIC_ERROR_MESSAGE)
  }
}

const setFormError = (formErrorMessage:string, formError = true) => {
  errorMessage.value = formErrorMessage
  error.value = formError
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"]),
      ref: "form"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          id: "name",
          maxlength: "80",
          name: "name",
          size: "20",
          type: "text",
          class: "form__input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, formData.value.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          id: "email",
          maxlength: "80",
          name: "email",
          size: "20",
          type: "email",
          class: "form__input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, formData.value.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          id: "company",
          maxlength: "80",
          name: "company",
          size: "20",
          type: "text",
          class: "form__input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.company) = $event))
        }, null, 512), [
          [_vModelText, formData.value.company]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          id: "00Nd00000092gp1",
          maxlength: "15",
          name: "00Nd00000092gp1",
          size: "20",
          type: "text",
          class: "form__input",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.subscriber) = $event))
        }, null, 512), [
          [_vModelText, formData.value.subscriber]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          id: "subject",
          maxlength: "80",
          name: "subject",
          size: "20",
          type: "text",
          class: "form__input",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.subject) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, formData.value.subject]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("textarea", {
          name: "description",
          class: "form__input",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.description) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, formData.value.description]
        ])
      ]),
      (_unref(recaptchaChallenge))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_unref(Vue3Recaptcha), {
              sitekey: _unref(RECAPTCHA_V2_SITE_KEY),
              onVerify: handleRecaptchaV2Response
            }, null, 8, ["sitekey"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_17
    ], 40, _hoisted_2)
  ], 64))
}
}

})